import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import store from './store'

import Local from '@/plugins/Local'
import Device from '@/plugins/Device'
import Offset from '@/plugins/Offset'
import Hub from '@/plugins/Hub'
import messages from '@/locales'
import GoogleAnalytics from '@/plugins/GoogleAnalytics'

Vue.use(Hub)
Vue.use(Device)
Vue.use(Offset)
Vue.use(VueI18n)
Vue.use(GoogleAnalytics)

export const i18n = new VueI18n({
  locale: 'en',
  messages
})

Vue.use(Local, { i18n: i18n })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
